/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = parseInt(levineVars.breakpoints.mobile_max);
 const navBreakpoint = parseInt(levineVars.breakpoints.mobile_navigation_max);
 const widescreenBreakpoint = parseInt(levineVars.breakpoints.desktop_max);
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/*
 * Globals
 ***************************/
  /* Window */
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    let isMobile = ( windowWidth <= mobileBreakpoint );
    let isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  /* Navigation */
    let isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, Flip);

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header__nav').length ) {
    const navResizeAction = (updated, navUpdated) => {
      if ( navUpdated ) {
        if ( isMobileNavigationActive ) {
          $('#site-nav').attr('role', 'dialog');
          $('#site-nav').attr('aria-modal', 'true');
        } else {
          const navEl = $('#site-nav').get(0);
          navEl.removeAttribute('role');
          navEl.removeAttribute('aria-modal');
        }
      }
    };

    navResizeAction(true, true);
    windowResizeActions.push(navResizeAction);

    const mobileNavContainer = $('.site-header__nav-inner');
    const mobileToggle = $('.site-header__nav-toggle');
    const mobileDismiss = $('.site-header__nav-dismiss');
    const firstFocusableMenuElement = $(mobileNavContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    if ( $(mobileNavContainer).find('.menu-item-has-children') ) {
      $(mobileNavContainer).find('.menu-item-has-children').each(function(){
        const toggle = $(this).children('a, button');
        const submenu = $(this).children('.sub-menu')

        let target = $(toggle).attr('aria-controls');
        let expanded = $(toggle).attr('aria-expanded');

        const toggleResizeAction = (updated, navUpdated) => {
          if ( navUpdated ) {
            if ( isMobileNavigationActive ) {
              $(toggle).attr('aria-controls', target);
              $(toggle).attr('aria-expanded', expanded);
            } else {
              $(toggle).get(0).removeAttribute('aria-controls');
              $(toggle).get(0).removeAttribute('aria-expanded');
            }
          }
        };
        toggleResizeAction(true);

        toggle.on('click', function(e){
          if ( isMobileNavigationActive ) {
            e.preventDefault();
            expanded = expanded == 'true' ? 'false' : 'true';
            $(toggle).attr('aria-expanded', expanded);
            submenu.slideToggle();
          }
        }).on('keypress', handleKeypressADA);
      });
    }

    $('.site-header__search-toggle').on('click', function(){
      const expanded = $(this).attr('aria-expanded') === 'true' ? 'false' : 'true';
      $(this).attr('aria-expanded', expanded);
      if ( expanded === 'true' ) {
        $('.site-header__search-form').addClass('active');
        $('.site-header__search-form input[type="search"]').focus();
      } else {
        $('.site-header__search-form').removeClass('active');
      }
      
    });


    $('.site-header__nav-toggle').on('click', function(){
      $(this).toggleClass('active');
      if ( $(this).hasClass('active') ) {
        $(mobileNavContainer).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          onComplete: function(){
            $(mobileNavContainer).focus();
          }
        });
      } else {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      }
    }).on('keypress', handleKeypressADA);

    $(mobileDismiss).on('click', function(){
      if ( isMobileNavigationActive ) {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        $(mobileToggle).removeClass('active');
        $(mobileToggle).focus();
      }
    }).on('keypress', handleKeypressADA);

    $(mobileNavContainer).on('keydown', function(e){
      if ( isMobileNavigationActive ) {
        if ( e.key == 'Escape' ) {
          mobileDismiss.click();
        } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  // gallery
  if ( $('.header-hero.has-background-type-video').length ) {
    $('.header-hero.has-background-type-video').each(function(){
      if ( $(this).closest('.header-carousel').length === 0 ) {
        const video = $(this).find('.header-hero__background video, .header-hero__embed');
        const player = new Plyr(video.get(0), {
          controls: ['play', 'mute'],
          hideControls: false,
          autoplay: true,
          muted: true,
          playsinline: true,
          loop: {
            active: true
          },
          iconUrl: levineVars.svgSpritesheet,
        });
      }
    });
  }
  
  if ( $('.header-carousel').length ) {
    $('.header-carousel').each(function(){
      const container = $(this).find('.header-carousel__inner');
      const slides = $(this).find('.header-carousel__inner > *');
      const backgrounds = $(this).find('.header-carousel__backgrounds-inner');
      const arrContainer = $(this).find('.header-carousel__controls-arrs');
      const curNum = $(this).find('.header-carousel__controls-nums--cur');
      const totNum = $(this).find('.header-carousel__controls-nums--tot');
      const autoplayToggle = $(this).find('.header-carousel__controls-autoplaytoggle');
      let isAutoplaying = autoplayToggle.hasClass('playing');
      const autoplaySpeed = $(this).data('autoplayspeed');
      
      totNum.text((( slides.length ) + '').padStart(2, '0'));
      
      slides.each(function() {
        if ( $(this).is('.header-hero') ) {
          const clone = $(this).find('.header-hero__background');
          clone.wrap('<div class="header-carousel__backgrounds-slide"></div>');
          
          backgrounds.append(clone.parent());
        }
      });
      
      const players = {
        
      };
      
      $(backgrounds).find('.header-hero__background').each(function(index){
        if ( $(this).is('.is-background-type-video') ) {
          const video = $(this).find('video, .header-hero__embed');
          const player = new Plyr(video.get(0), {
            controls: ['play-large', 'mute'],
            hideControls: false,
            autoplay: index === 1 ? true : false,
            muted: true,
            playsinline: true,
            loop: {
              active: true
            },
            iconUrl: levineVars.svgSpritesheet,
          });
          
          players[index] = player;
          
          if ( index === 0 ) {
            player.play();
          }
        }
      });
      
      
      backgrounds.on('init', function(){
        if ( players.hasOwnProperty(0) ) {
          players[0].play();
        }
      }).slick({
        fade: true,
        arrows: false
      });
      
      container.slick({
        swipe: false,
        appendArrows: arrContainer,
        asNavFor: backgrounds,
        prevArrow: prevArrow,
        nextArrow: nextArrow
      });
      
      const autoplayTL = gsap.timeline({
        repeat: -1,
        paused: !isAutoplaying,
        onRepeat: function() {
          $(container).slick('slickNext');
        }
      });
      
      $(container).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        curNum.text(((nextSlide + 1) + '').padStart(2, '0'));
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].pause();
        }
        
        if ( isAutoplaying ) {
          autoplayTL.seek(0);
        }
      });
      
      $(container).on('afterChange', function(event, slick, currentSlide){
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].play();
        }
      });
       
       
       
      autoplayTL.to($(this).find('.header-carousel__progress-per'), {
        scaleX: 1,
        ease: 'none',
        duration: autoplaySpeed
      });
      
      $(autoplayToggle).on('click', function(){
        isAutoplaying = !isAutoplaying;
        if ( isAutoplaying ) {
          $(autoplayToggle).removeClass('paused');
          $(autoplayToggle).addClass('playing');
          $(this).find('.screen-reader-text').text( $(this).data('pausetext') );
          autoplayTL.play();
          console.log(autoplayTL);
        } else {
          $(autoplayToggle).removeClass('playing');
          $(autoplayToggle).addClass('paused');
          $(this).find('.screen-reader-text').text( $(this).data('playtext') );
          autoplayTL.pause();
        }
      });
    });
  }

  if ( $('.cards-carousel').length ) {
    $('.cards-carousel').each(function(){
      const container = this;
      container.style.setProperty('--container-width', $(container).width() + 'px');
      const content = $(container).find('.cards-carousel__inner').children('.acf-innerblocks-container');
      const endCard = $(content).find('.carousel-end-card');
      const list = $(this).find('.cards-carousel__list');
      if ( endCard.length ) {
        $(endCard).each(function(){
          const li = document.createElement('li');
          li.classList.add('cards-carousel__list-item');
          list.append(li);
          li.append(this);
        });
        
      }
      const definitiveCount = list.children().length;
      let count = definitiveCount;
      const infinite = $(list).hasClass('cards-carousel--finite') ? false : true;
      let progressFill = null;

      const initSlick = () => {
        if ( list.find('.slick-gallery-nav__progress') ) {
          list.find('.slick-gallery-nav__progress').remove();
        }

        list.slick({
          variableWidth: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          arrowsPlacment: 'afterSlides',
          infinite: infinite
        });

        list.append('<div class="slick-gallery-nav__progress"><span class="slick-gallery-nav__progress-fill"></span></div>');
        progressFill = list.find('.slick-gallery-nav__progress-fill');

        progressFill.css({
          'width': ( 100 / count ) + '%'
        });
      };

      let responsiveRules = [
        {
          breakpoint: widescreenBreakpoint,
          group: 3
        },
        {
          breakpoint: mobileBreakpoint,
          group: 2
        },
        {
          breakpoint: 0,
          group: 1
        }
      ];

      let columns = 0;

      const groupitems = (list) => {
        let cssColumns = window.getComputedStyle(container).getPropertyValue('--columns');
        let newColumns = isNaN(parseInt(cssColumns)) ? 1 : Math.max((parseInt(cssColumns) - 1), 1);
        if ( newColumns === columns ) {
          return;
        }

        columns = newColumns;
        count = definitiveCount - columns + 1;

        if ( $(list).hasClass('slick-initialized') ) {
          $(list).slick('unslick');
        }

        if ( list.find('.cards-carousel__list-item-group') ) {
          list.find('.cards-carousel__list-item-group').children().unwrap();
        }

        if ( columns === 1 ) {
          initSlick();
          return;
        }

        const lastChild = list.children().last();
        const toGroup = lastChild.prevUntil(':nth-last-child(' + (columns + 1) + ')').addBack();
        toGroup.wrapAll('<div class="cards-carousel__list-item-group"></div>');

        initSlick();
      }

      if ( infinite === false ) {
        groupitems(list);

        $(window).on('resize', debounce(function(){
          groupitems(list);
        }));
      } else {
        initSlick();
      }
      
      

      $(list).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        if ( progressFill !== null ) {
          gsap.to(progressFill, {
            width: ( (nextSlide + 1) * (100 / count) ) + '%',
            ease: 'power3.inOut',
            duration: 0.4
          });
        }
      });
      
      $(window).on('resize', debounce(function(){
        container.style.setProperty('--container-width', $(container).width() + 'px');
      }))
    });
  }

  if ( $('.testimonials').length ) {
    $('.testimonials').each(function(){
      const inner = $(this).find('.testimonials__inner-blocks');
      const controls = $(this).find('.testimonials__controls');
      const quotes = inner.find('.wp-block-pullquote');
      const count = quotes.length;
      const progressFill = controls.find('.slick-gallery-nav__progress-fill');

      if ( quotes.length > 1 ) {
        controls.addClass('active');

        progressFill.css({
          'width': ( 100 / count ) + '%'
        });

        const initSlick = () => {
          inner.slick({
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            appendArrows: controls,
            arrowsPlacment: 'split',
            mobileFirst: true,
            responsive: [
              {
                breakpoint: mobileBreakpoint + 1,
                settings: 'unslick'
              }
            ]
          });

          $(inner).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            gsap.to(progressFill, {
              width: ( (nextSlide + 1) * (100 / count) ) + '%',
              ease: 'power3.inOut',
              duration: 0.4
            });
          });
        }

        if ( isMobile ) {
          initSlick();
        }

        const onResizeAction = (updated, navUpdated) => {
          if ( updated && isMobile ) {
            initSlick();
          }
        }

        windowResizeActions.push(onResizeAction);
      } else {
        controls.remove();
      }
    });
  }
  
  if ( $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').length ) {
    $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').each(function(){
      const target = $(this).find('video, .wp-block-embed__wrapper');
      const el = target.get(0);
      
      const isHero = $(el).closest('.video-hero').length > 0 ? true : false;
      const controls = isHero ? ['play'] : ['play-large', 'play', 'mute', 'volume', 'progress', 'current-time', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : ( isHero ? true : false);
      
      const args = {
        autoplay: shouldAutoplay,
        controls: $(el).is('video') && el.hasAttribute('controls') ? ( el.getAttribute('controls') === 'false' ? [] : controls ) : ($(el).is('video') ? [] : controls),
        playsinline: el.hasAttribute('playsinline') ? (el.getAttribute('playsinline') === 'true' || el.getAttribute('playsinline') === '') : false,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        muted: shouldAutoplay ? true : ( el.hasAttribute('muted') ? (el.getAttribute('muted') === 'true' || el.getAttribute('muted') === '') : false ),
        iconUrl: levineVars.svgSpritesheet,
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-audio').length ) {
    $('.wp-block-audio').each(function() {
      const target = $(this).find('audio');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        iconUrl: levineVars.svgSpritesheet,
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }
  
  if ( $('.levine-dropdown').length ) {
    $('.levine-dropdown').each(function(){
      const container = this;
      const trigger = this.querySelector('.levine-dropdown__toggle');
      const inner = this.querySelector('.levine-dropdown__inner');
      const selectedText = trigger.querySelector('span');
      const optionsList = this.querySelector('.levine-dropdown__dropdown');  
      const options = this.querySelectorAll('.levine-dropdown__dropdown li');
      const hiddenField = this.querySelector('.levine-dropdown__hidden-input');
      const labelEx = options;

      let isExpanded = false;

      $(optionsList).css({
        width: 'auto'
      });

      console.log(  Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px' );
      
      $(inner).css({
        'width': Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px'
      });
      
      $(optionsList).css({
        width: '100%'
      });

      /**
        Event handlers
      */
      const handleTriggerKeypresses = function (e) {
        switch(e.key) {
          case 'ArrowUp':
            e.preventDefault();
            
            if(isExpanded) {
              selectPreviousOption();
            } else {
              expandOptions();
            }
            
            break;
            
          case 'ArrowDown':
            e.preventDefault();
            
            if(isExpanded) {
              selectNextOption();
            } else {
              expandOptions();
              selectFirstOption();
            }
            
            break;
            
          case 'Home':
            if(isExpanded) {
              selectFirstOption();
            }
            
            break;
            
          case 'End':
            if(isExpanded) {
              selectLastOption();
            }
            
            break;
            
          case 'Tab':
            collapseOptions();
            break;
            
          case 'Escape':
          case 'Enter':
            if(isExpanded) {
              e.preventDefault();
              collapseOptions();
              if ( e.target.closest('[aria-modal="true"]') !== null ) {
                e.stopPropagation();
              }
            }
            
            break;
        }
      }

      const handleBodyClick = function (e) {
        if(!container.contains(e.target) && isExpanded) {
          collapseOptions();
        }
      }

      const handleTriggerClick = function () {
        if(isExpanded) {
          collapseOptions();
          trigger.focus();
        } else {
          expandOptions();
        }
      }


      /**
        Show/hide option list
      */
      const collapseOptions = function () {
        trigger.setAttribute('aria-expanded', false);
        optionsList.classList.remove('is-visible');
        isExpanded = false;
      }

      const expandOptions = function () {
        trigger.setAttribute('aria-expanded', true);
        optionsList.classList.add('is-visible');
        isExpanded = true;
      }


      /**
        Option selection
      */
      const selectFirstOption = function () {
        var firstOption = options[0];
        selectOption(firstOption);
      }

      const selectLastOption = function () {
        var lastOption = options[options.length-1];
        selectOption(lastOption);
      }

      const selectNextOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex + 1 < options.length) {
            var nextOption = options[currentOptionIndex + 1];
            selectOption(nextOption);
          }
        }
      }

      const selectPreviousOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex - 1 >= 0) {
            var previousOption = options[currentOptionIndex - 1];
            selectOption(previousOption);
          }
        }
      }

      const selectOption = function (option) {
        unselectAllOptions();
        option.setAttribute('aria-selected', true);
        trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
        selectedText.innerHTML = option.innerHTML;
        
        // Scroll item into view
        
        
        // Update the hidden field
        hiddenField.value = $(option).data('value');
        $(hiddenField).trigger('change');
      }

      const unselectAllOptions = function () {  
        options.forEach(function(option) {
          option.removeAttribute('aria-selected');
        });
      }

      // Handle keyboard and mouse interactions on the trigger bar
      trigger.addEventListener('keydown', handleTriggerKeypresses);
      trigger.addEventListener('click', handleTriggerClick);
      
      // Select options when they are clicked
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          unselectAllOptions();
          selectOption(e.target);
          collapseOptions();
          trigger.focus();
        });
      });
      
      // Collapse the dropdown when the user clicks off
      document.addEventListener('click', handleBodyClick);
    });
  }

  //accordion
  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }
  
  if ( $('.logo-ticker').length ) {
    $('.logo-ticker').each(function() {
      const strip = $(this).find('.logo-ticker__strip');
      const thisRef = this;
      let oldSize = $(window).width();
      let stripW = strip.width();
      let curW = stripW;
      let clones = 0;
      let clonesArr = [];
      
      let speed = isMobile ? stripW / 24 : stripW / 50;
      
      while ( curW && curW !== 0 && curW < oldSize * 2 ) {
        curW += stripW;
        clones++;
        const clone = strip.clone(false);
        $(this).append(clone);
        
        gsap.set(clone, {
          x: ( clones * 100 ) + '%'
        });
        
        clonesArr.push(clone);
      }
      
      const loop = gsap.timeline({
        repeat: -1
      });
      
      loop.to(strip, {
        x: '-=100%',
        ease: 'linear',
        duration: () => {
          return speed;
        }
      });
      
      for ( let i = 0; i < clonesArr.length; i++ ) {
        loop.to(clonesArr[i], {
          x: '-=100%',
          ease: 'linear',
          duration: () => {
            return speed;
          }
        }, '0');
      }
      
      $(window).on('resize', function(){
        speed = isMobile ? stripW / 13 : stripW / 30
        if ( oldSize !== $(window).width() && oldSize < $(window).width() ) {
          const newW = $(window).width();
          if ( newW * 2 > curW ) {
            while ( curW && curW !== 0 && curW < newW * 2 ) {
              curW += stripW;
              clones++;
              const clone = strip.clone(false);
              $(thisRef).append(clone);
              
              gsap.set(clone, {
                x: ( clones * 100 ) + '%'
              });
              
              loop.to(clone, {
                x: '-=100%',
                ease: 'linear',
                duration: () => {
                  return speed;
                }
              }, '0');
              
              clonesArr.push(clone);
            }
            
            oldSize = newW;
          }
        }
      });
    });
  }
  
  $('body').on('click', '.content-card__image', function(e){
    const card = $(e.target).closest('.content-card');
    const link = card.find('.content-card__title a').get(0);
    if ( link ) {
      e.preventDefault();
      if ( link.hasAttribute('href') && link.getAttribute('href') !== '#' ) {
        if ( link.getAttribute('target') === '_blank' ) {
          window.open(link.getAttribute('href'), '_blank');
        } else {
          window.location.href = link.getAttribute('href');
        }
      }
    }
  });

  if ( $('.rollover-links').length ) {
    $('.rollover-links').each(function(){
      const links = $(this).find('.rollover-links-links .content-card.is-style-rollover-links');
      const imageArea = $(this).find('.rollover-links-content__images');

      links.each(function(index){
        const img = this.querySelector('.content-card__image img');
        const slide = document.createElement('div');
        slide.classList.add('rollover-links-content__images-slide');
        slide.appendChild(img.cloneNode(true));
        slide.appendChild(img.cloneNode(true));
        imageArea.append(slide);

        if ( index !== 0 ) {
          gsap.set(slide, {
            opacity: 0,
            visibility: 'hidden',
            zIndex: 2
          });
        } else {
          $(this).addClass('is-style-rollover-links--active');
        }

        $(this).on('mouseenter', function(){
          $(this).addClass('is-style-rollover-links--active');
          links.not(this).removeClass('is-style-rollover-links--active');

          const current = imageArea.find('.rollover-links-content__images-slide').eq(index);
          const others = imageArea.find('.rollover-links-content__images-slide').not(current);

          const tl = gsap.timeline({
            onStart: function() {
              gsap.set(current, {
                visibility: 'visible',
                zIndex: 3
              });

              gsap.set(others, {
                zIndex: 2
              })
            }
          });

          

          tl.to(current, {
            opacity: 1,
            visibility: 'visible',
            duration: 0.4,
            overwrite: true,
            ease: 'power3.inOut'
          });

          tl.to(others, {
            opacity: 0,
            visibility: 'hidden',
            zIndex: 2,
            duration: 0.4,
            ease: 'power3.inOut',
            overwrite: true,
            onComplete: function() {
              gsap.set(others, {
                visibility: 'hidden',
                zIndex: 2
              });
            }
          });
        });
      });
    });
  }

  if ( $('.article-card-container.search-course-results').length ) {
    $('.article-card-container.search-course-results').each(function(){
      const scrollMonitor = new ScrollableContainer(this, {
        classTarget: this.parentElement,
      });
    });
  }

  if ( $('.archive-block__filter-option-list').length ) {
    $('.archive-block__filter-option-list').each(function(){  
      const scrollMonitor = new ScrollableContainer(this, {
        classTarget: this.parentElement,
      });
    });
  }

  if ( $('.featured-course-filter__button').length ) {
    $('.featured-course-filter__button').on('click', function(){
      const taxonomy = $(this).data('taxonomy');
      const term = $(this).data('term');

      const input = document.querySelector('input[name="' + taxonomy + '"][value="' + term + '"]');
      if ( input !== null && input instanceof HTMLInputElement ) {
        input.checked = true;
        $(input).trigger('change');
      }
    });
  }

  if ( $('.subnav').length ) {
    $('.subnav').each(function(){
      const toggle = $(this).find('.subnav-toggle');
      const inner = $(this).find('.subnav__inner');
      const links = $(this).find('.subnav-links');
      const firstFocusable = inner.find('a, button, input').eq(0).get(0);
      const lastFocusable = inner.find('a, button, input').last().get(0);

      const scrollMonitor = new ScrollableContainer(links.get(0), {
        classTarget: this,
        scrollType: 'horizontal',
        arrows: true,
        appendArrows: inner.get(0)
      });

      toggle.on('click', function(){
        const expanded = $(this).attr('aria-expanded') === 'true' ? 'false' : 'true';
        $(this).attr('aria-expanded', expanded);
        if ( expanded === 'true' ) {
          $(inner).slideDown();
          $(inner).attr('tabindex', '-1');
          $(inner).focus();
        } else {
          $(inner).slideUp();
          $(inner).removeAttr('tabindex');
          $(toggle).focus();
        }
      });
    });
  }
  /* END GUTENBERG SCRIPTS */

  /* ARCHIVE BLOCK SCRIPTS */
  if ( $('.archive-block').length ) {
    $('.archive-block').each(function(){
      const archiveBlock = $(this);
      const archiveFeed = $(this).find('.archive-block__feed');
      const archivePagination = $(this).find('.archive-block__pagination-container');

      const archiveFilterForm = $(this).find('.archive-block__header');
      const archiveSortInputs = $(this).find('.archive-block__sort__input-input');
      const archiveSearchInput = $(this).find('.archive-block__search-input');
      const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

      const archiveFilterGroups = $(this).find('.archive-block__filter');
      const archiveFilterChipList = $(this).find('.archive-block__chip-list');


      const base = $(this).data('baseurl');
      let currentURL = $(this).data('currenturl');
      const initPage = $(this).data('page');
      const postType = $(this).data('posttype');
      const exclude = $(this).data('exclude');

      let updateArchive;
      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: 'default',
        postType: postType,
        search: false,
        mode: false,
        exclude: exclude,
        taxonomy: false,
        term: false,
        filters: {},
        constantFilters: this.hasAttribute('data-constantfilters') ? $(this).data('constantfilters') : [],
      };

      if ( this.hasAttribute('data-postsper') ) {
        stateObj.postsPerPage = $(this).data('postsper');
      }

      if ( this.hasAttribute('data-cardargs') ) {
        stateObj.cardArgs = $(this).data('cardargs');
      }
      
      if ( this.hasAttribute('data-taxonomy') ) {
        stateObj.taxonomy = $(this).data('taxonomy');
      }
      
      if ( this.hasAttribute('data-term') ) {
        stateObj.term = $(this).data('term');
      }
      
      if ( this.hasAttribute('data-mode') ) {
        stateObj.mode = $(this).data('mode');
      }
      
      if ( this.hasAttribute('data-searchterm') ) {
        stateObj.search = $(this).data('searchterm');
      }

      const updateURLFromFilters = () => {
        const baseurl = base[0] === '/' ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if ( stateObj.sort !== 'default' ) {
          url.searchParams.append('sort', stateObj.sort);
        }

        if ( stateObj.mode === 'search' && stateObj.search !== false ) {
          url.searchParams.append('s', stateObj.search);
        } else if ( stateObj.search !== false ) {
          url.searchParams.append('search', stateObj.search);
        }

        if ( Object.keys(stateObj.filters).length ) {
          for ( const filterType in stateObj.filters ) {
            if ( Array.isArray(stateObj.filters[filterType]) ) {
              url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      const updateFilterChips = () => {
        const visibleFilters = [];

        if ( stateObj.search ) {
          visibleFilters.push({ type: 'search', value: stateObj.search, isArray: false, label: stateObj.search } );
        } 

        for ( const activeFilter in stateObj.filters ) {
          console.log(activeFilter, stateObj.filters[activeFilter]);
          let label = archiveFilterForm.find('input[name="' + activeFilter + '"][value="' + stateObj.filters[activeFilter] + '"]').parent().find('label').text().trim();
          if ( stateObj.filters[activeFilter] !== 'all' ) {
            if ( stateObj.filters[activeFilter] instanceof Array ) {
              stateObj.filters[activeFilter].forEach(value => {
                visibleFilters.push({ type: activeFilter, value: value, isArray: true, label});
              });
            } else {
              visibleFilters.push({ type: activeFilter, value: stateObj.filters[activeFilter], isArray: false, label} );
            }
            
          } 
        }

        if ( visibleFilters.length ) {
          archiveFilterChipList.text('');

          const clearLi = document.createElement('li');
          clearLi.classList.add('archive-block__chip-list-clear');
          const clearFilters = document.createElement('a');
          clearFilters.classList.add('has-date-font-size');
          clearFilters.setAttribute('href', stateObj.base);
          clearFilters.textContent = 'Clear All';

          clearFilters.addEventListener('click', function(e){
            e.preventDefault();
            const allInputs = archiveFilterForm.find('input[type="radio"][value="all"]');
            if ( allInputs.length ) {
              allInputs.each(function(){
                $(this).prop('checked', true);
                stateObj.filters[ $(this).attr('name') ] = 'all';
              });
            }
            archiveSearchInput.val('');
            stateObj.search = false;
            updateURLFromFilters();
          });

          clearLi.appendChild(clearFilters);

          if ( stateObj.search ) {
            const searchingBy = document.createElement('li');
            searchingBy.classList.add('archive-block__chip-list-label');
            searchingBy.style.fontWeight = '800';
            searchingBy.textContent = 'Searching by:';
            archiveFilterChipList.append(searchingBy);

            // splice search chip from visible filters
            const searchFilter = visibleFilters.splice(0, 1);
            searchFilter.forEach(filter => {
              const li = document.createElement('li');
              li.classList.add('archive-block__chip-list-item', 'active-filter-chip');
              const buttonWrapper = document.createElement('div');
              buttonWrapper.classList.add('wp-block-button', 'is-style-fill--no-accent', 'has-icon', 'is-small');
              const button = document.createElement('button');
              button.classList.add('wp-block-button__link', 'has-flash-background-color', 'has-background', 'has-red-color', 'has-text-color');
              button.textContent = filter.label;

              button.insertAdjacentHTML('beforeend', '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewbox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"><line x1="2" y1="2" x2="10" y2="10"></line><line x1="2" y1="10" x2="10" y2="2"></line></svg>');

              button.setAttribute('type', 'button');
              button.setAttribute('aria-label', 'Remove search term ' + filter.label);
              button.addEventListener('click', function(){
                const input = archiveFilterForm.find('.archive-block__search-input');
                console.log(input);
                if ( input.length ) {
                  input.val('');
                  archiveSearchConfirm.trigger('click');
                }
              });

              buttonWrapper.appendChild(button);
              li.appendChild(buttonWrapper);
              archiveFilterChipList.append(li);
            });
          }

          if ( visibleFilters.length > 0 ) {
            const filteringBy = document.createElement('li');
            filteringBy.classList.add('archive-block__chip-list-label');
            filteringBy.style.fontWeight = '800';
            filteringBy.textContent = 'Filtering by:';
            archiveFilterChipList.append(filteringBy);

            visibleFilters.forEach(filter => {
              const li = document.createElement('li');
              li.classList.add('archive-block__chip-list-item', 'active-filter-chip');
              const buttonWrapper = document.createElement('div');
              buttonWrapper.classList.add('wp-block-button', 'is-style-fill--no-accent', 'has-icon', 'is-small');
              const button = document.createElement('button');
              button.classList.add('wp-block-button__link', 'has-flash-background-color', 'has-background', 'has-red-color', 'has-text-color');
              button.textContent = filter.label;

              button.insertAdjacentHTML('beforeend', '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewbox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"><line x1="2" y1="2" x2="10" y2="10"></line><line x1="2" y1="10" x2="10" y2="2"></line></svg>');

              button.setAttribute('type', 'button');
              button.setAttribute('aria-label', 'Remove filter ' + filter.label);
              button.addEventListener('click', function(){
                if ( filter.isArray ) {
                  const input = archiveFilterForm.find('input[name="' + filter.type + '"][value="' + filter.value + '"]');
                  if ( input.length ) {
                    input.prop('checked', false);
                    input.trigger('change');
                  }
                } else {
                  const input = archiveFilterForm.find('input[name="' + filter.type + '"][value="' + filter.value + '"]');
                  if ( input.length ) {
                    input.prop('checked', false);
                  }

                  const allInput = archiveFilterForm.find('input[name="' + filter.type + '"][value="all"]');
                  if ( allInput.length ) {
                    allInput.prop('checked', true);
                    allInput.trigger('change');
                  }
                }
              });
              
              buttonWrapper.appendChild(button);
              li.appendChild(buttonWrapper);
              archiveFilterChipList.append(li);
            });
          }

          archiveFilterChipList.append(clearLi);
          archiveFilterChipList.show();
        } else {
          archiveFilterChipList.text('');
          archiveFilterChipList.hide();
        }
      };

      if ( archiveFilterGroups.length ) {
        $(archiveFilterGroups).each(function(index) {
          const toggleButton = $(this).find('.archive-block__filter-header-button');
          const inputs = $(this).find('input');

          if ( toggleButton.length ) {
            const inner = $(this).find( '#' + toggleButton.attr('aria-controls') );
            toggleButton.on('click', function(){
              const expanded = $(this).attr('aria-expanded') === 'true' ? 'false' : 'true';
              $(this).attr('aria-expanded', expanded);
              if ( expanded === 'true' ) {
                $(inner).slideDown();
              } else {
                $(inner).slideUp();
              }
            }).on('keypress', handleKeypressADA);

            if ( isMobile ) {
              toggleButton.attr('aria-expanded', 'false');
              $(inner).hide();
            } else if ( index >= 2 ) {
              toggleButton.attr('aria-expanded', 'false');
              $(inner).hide();
            }
          }

          $(inputs).each(function(){
            const name = $(this).attr('name');
            const type = $(this).attr('type');
            const val = $(this).attr('value');

            if ( $(this).is(':checked') ) {
              if ( type === 'radio' ) {
                stateObj.filters[ name ] = val;
              } else {
                if ( stateObj.filters.hasOwnProperty(name) ) {
                  stateObj.filters[ name ].push( val );
                } else {
                  stateObj.filters[ name ] = [ val ];
                }
              }
            }

            $(this).on('change', function(){
              if ( $(this).is(':checked') ) {
                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  stateObj.filters[ name ].push( val );
                }
              } else if ( type === 'checkbox' ) {
                stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
              } else if ( type === 'hidden' ) {
                stateObj.filters[ name ] = $(this).val();
              }
              
              updateURLFromFilters();
            });
          });
        });
      }

      if ( archiveSortInputs.length ) {
        $(archiveSortInputs).each(function(){
          const val = $(this).attr('value');
          
          if ( $(this).is(':checked') ) {
            stateObj.sort = val;
          }
          
          $(this).on('change', function(){
            if ( $(this).is(':checked') ) {
              stateObj.sort = val;
              updateURLFromFilters();
            }
          });
        });
      }

      if ( archiveSearchInput.length ) {
        if ( archiveSearchInput.val() !== '' ) {
          stateObj.search = archiveSearchInput.val();
        }

        $(archiveSearchInput).on('keyup', function(e){
          if ( $(this).val() === '' && stateObj.search !== false ) {
            stateObj.search = false;
            updateURLFromFilters();
          }
        })
      }
      

      if ( archiveSearchConfirm.length ) {
        archiveSearchConfirm.on('click', function(){
          const searchQuery = archiveSearchInput.val();
          if ( searchQuery !== '' ) {
            if ( stateObj.search !== searchQuery ) {
              stateObj.search = searchQuery;
            }

            updateURLFromFilters();
          } else {
            if ( stateObj.search !== false ) {
              stateObj.search = false;
              updateURLFromFilters();
            }
          }
        }).on('keypress', handleKeypressADA);
      }

      if ( archiveFilterForm.length ) {
        archiveFilterForm.on('submit', function(e){
          e.preventDefault();
          if ( archiveSearchConfirm.length ) {
            archiveSearchConfirm.trigger('click');
          }
        });
      }



      $(archivePagination).on('click', 'a', function(e){
        e.preventDefault();
        if ( ajaxIsLoading === false ) {
          const url = $(e.target).attr('href');
          let page = 1;
          const urlparts = url.split('?')[0].split('/');
          let parsedNum = false;
          for ( let i = urlparts.length - 1; i >= 0; i-- ) {
            if ( urlparts[ i ] != '' ) {
              const parsed = parseInt( urlparts[ i ] );
              if ( !isNaN(parsed) ) {
                parsedNum = parsed;
                break;
              }
            }
          }

          if ( parsedNum !== false ) {
            page = parsedNum;
          }

          console.log(page);


          stateObj.url = url;
          stateObj.page = page;

          updateArchive();
        }
      }).on('keypress', 'a', function(e){
        e.preventDefault();
        $(this).trigger('click');
      });

      const initState = stateObj;
      updateFilterChips(); // initial state is set, so render filter chips

      window.addEventListener('popstate', function(event){
        if ( Object.keys(event.state).length == 0 ) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });


      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass('loading');
        gsap.to(window, {
          scrollTo: archiveBlock.get(0),
          duration: 0.8,
          ease: 'power1.inOut'
        });


        if ( frompopstate === false ) {
          history.pushState(stateObj, '', stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude,
          taxonomy: stateObj.taxonomy,
          term: stateObj.term,
          mode: stateObj.mode
        };

        if ( stateObj.search !== false ) {
          args.search = stateObj.search;
        } if ( stateObj.hasOwnProperty('postsPerPage') ) {
          args.postsPerPage = stateObj.postsPerPage;
        } if ( stateObj.hasOwnProperty('cardArgs') ) {
          args.cardArgs = stateObj.cardArgs;
        } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
          args.filters = stateObj.filters;
        } if ( stateObj.hasOwnProperty('constantFilters') && stateObj.constantFilters.length ) {
          args.constantFilters = stateObj.constantFilters;
        }

        console.log(args);

        $.post(levineVars.ajaxURL, {
          action: 'levine_get_archive',
          args: args
        }, function(data) {
          console.log(data);
          try {
            const res = JSON.parse(data);
            const state = Flip.getState( archiveFeed.get(0).querySelector('li') );
            console.log(res);
            $(archiveFeed).html( res.results );
            $(archivePagination).html( res.pagination );
            if ( archiveBlock.find('.archive-block__num-results').length ) {
              archiveBlock.find('.archive-block__num-results-text').text( res.num_results );
            }
            updateFilterChips();
            

            Flip.from(state, {
              absolute: true,
              duration: 0.6,
              onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
              onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
            });
          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          $(archiveBlock).removeClass('loading');
          ajaxIsLoading = false;
        });
      };
    });
  }
  /* END ARCHIVE BLOCK SCRIPTS */
  
  // remove 0.00 and make it free!
  function runZeroforFree(){
    $.each($(".tribe-amount"),function(){
      console.log($(this).text());
      if($(this).text() === '0.00'){
        $(this).text('Free');
        $(this).parent().find('.tribe-currency-symbol').text('');
      }
    });
  }
runZeroforFree();
  $(document).on('click', '.tribe-tickets__tickets-item-quantity-add', function(){
  console.log("Quantity add clicked");
  runZeroforFree();
});
  $(document).on('click', '.tribe-tickets__tickets-item-quantity-remove', function(){
  console.log("Quantity remove clicked");
  runZeroforFree();
});
  $('body').on('click', '.tribe-tickets__tickets-footer', function(){
  console.log("Buy clicked");
  runZeroforFree();
});

jQuery(document).on('tribe_dialog_show', function(){
  console.log('Dialog opened');
  runZeroforFree();
});
  
  //links on checkout go to a new tab
  $('#checkout, .woocommerce-checkout').find('a').attr('target', '_blank');

  
  
  
}); // document ready end

window.addEventListener("message", function(event) {
  console.log("postMessage:", event.data, "from:", event.origin, event);
});

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  let oldNavState = isMobileNavigationActive;
  isMobile = ( windowWidth <= mobileBreakpoint );
  isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    const navUpdated = oldNavState != isMobileNavigationActive;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated, navUpdated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/
function gutenbergSlickify(el) {
  const count = $(el).find('figure').length;

  const captions = [];

  $(el).find('figure').each(function(){
    $(this).get(0).style.setProperty('--thumbnail-image', 'url(' + $(this).find('img').attr('src') + ')');
    if ( $(this).find('figcaption').length ) {
      $(this).addClass('has-caption');
      captions.push( $(this).find('figcaption').clone(true) );
      $(this).find('figcaption').remove();
    } else {
      captions.push('<div style="height:10px;"></div>');
    }
  });

  $(el).find('.blocks-gallery-item').each(function(){
    $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
  });

  $(el).find('.blocks-gallery-item__caption').each(function(){
    $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
  });

  $(el).addClass('slick-gallery-grid').addClass('alignfull').removeClass('blocks-gallery-grid');

  $(el).removeClass('wp-block-gallery').wrap('<div></div>');
  const parent = $(el).parent();
  parent.addClass('slick-gallery').addClass('alignfull').addClass('content-margins').removeClass('wp-block-gallery').append(`
  <div class="alignwide slick-gallery-nav">
    <div class="slick-gallery-nav__inner">
      <div class="slick-gallery-nav__captions-outer">
        <div class="slick-gallery-nav__captions"></div>
      </div>
      <div class="slick-gallery-nav__progress"><span class="slick-gallery-nav__progress-fill"></span></div>
    </div>
    <div class="slick-gallery-nav__count">
      <b><span class="slick-gallery-nav__count__cur">1</span></b> of <b>` + count +`</b>
    </div>
  </div>
  <div class='slick-gallery-bigNav slick-gallery-bigNav-prev'></div><div class='slick-gallery-bigNav slick-gallery-bigNav-next'></div>`);


  const nav = $(el).parent().find('.slick-gallery-nav');
  const captionsContainer = nav.find('.slick-gallery-nav__captions');
  const progressFill = nav.find('.slick-gallery-nav__progress-fill');

  for (let i = 0; i < captions.length; i++) {
    captionsContainer.append( captions[i] );
  }

  captionsContainer.slick({
    adaptiveHeight: true,
    arrows: false,
    swipe: false,
    fade: true
  });

  $(el).slick({
    adaptiveHeight: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    appendArrows: nav,
    asNavFor: captionsContainer,
    centerMode: true,
    centerPadding: 'var(--gallery-padding, 10vw)',
    arrowsPlacement: 'afterSlides'
  });
  $('.slick-gallery-bigNav-prev').on('click', function () {
    $(el).slick('slickPrev');
  });
  
  $('.slick-gallery-bigNav-next').on('click', function () {
    $(el).slick('slickNext');
  });

  progressFill.css({
    'width': ( 100 / count ) + '%'
  });

  $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    nav.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
    gsap.to(progressFill, {
      width: ( (nextSlide + 1) * (100 / count) ) + '%',
      ease: 'power3.inOut',
      duration: 0.4
    });
  });

  $(el).get(0).style.setProperty('--gallery-padding', Math.floor( ((windowWidth - $(nav).width()) / 2) - 8 )+ 'px' );

  $(window).on('resize', debounce(function(){
    $(el).get(0).style.setProperty('--gallery-padding', Math.floor( ((windowWidth - $(nav).width()) / 2) - 8 )+ 'px' );
  }));
  
  function removeFigureLinks() {
    $('.slick-gallery figure.wp-block-image').each(function () {
      const $link = $(this).find('> a');
      if ($link.length) {
        const $img = $link.find('img');
        $link.replaceWith($img);
      }
    });
  }
  removeFigureLinks();
  
  
}


function debounce(func){
  var timer;
  return function(event){
    if(timer) clearTimeout(timer);
    timer = setTimeout(func,100,event);
  };
}

class ScrollableContainer {
  constructor(scrollableNode, args = {}) {
    const {
      scrollType,
      scrollPadding = 32,
      classTarget = null,
      arrows = false,
      appendArrows = null
    } = args;

    this.scroller = scrollableNode;
    this.classTarget = classTarget && classTarget instanceof HTMLElement ? classTarget : this.scroller;
    this.scrollType = scrollType && ['horizontal', 'vertical'].includes(scrollType) ? scrollType : 'vertical';
    this.scrollPadding = typeof scrollPadding === 'number' ? scrollPadding : 32;
    this.arrows = typeof arrows === 'boolean' ? arrows : false;
    this.appendArrows = appendArrows && appendArrows instanceof HTMLElement ? appendArrows : this.classTarget;

    this.assessScroll();

    $(window).on('resize', (() => {
      this.assessScroll();
    }).bind(this));

    ScrollTrigger.create({
      scroller: this.scroller,
      horizontal: this.scrollType === 'horizontal',
      start: this.scrollPadding * -1,
      end: (() => {
        return this.scrollType === 'horizontal' ? this.scroller.scrollWidth - this.scroller.clientWidth : this.scroller.scrollHeight - this.scroller.clientHeight;
      }).bind(this),
      // markers: true,
      toggleClass: {
        targets: this.classTarget,
        className: 'can-scroll-positive'
      }
    })

    ScrollTrigger.create({
      scroller: this.scroller,
      horizontal: this.scrollType === 'horizontal',
      start: this.scrollPadding,
      end: (() => {
        return this.scrollType === 'horizontal' ? this.scroller.scrollWidth - this.scroller.clientWidth + this.scrollPadding : this.scroller.scrollHeight - this.scroller.clientHeight + this.scrollPadding;
      }).bind(this),
      // markers: true,
      toggleClass: {
        targets: this.classTarget,
        className: 'can-scroll-negative'
      }
    })

    if ( this.arrows !== null && this.arrows !== false ) {
      this.appendArrows.insertAdjacentHTML('afterbegin', prevArrow);
      this.appendArrows.insertAdjacentHTML('beforeend', nextArrow);

      this.nextArrow = this.appendArrows.querySelector('.slick-next');
      this.prevArrow = this.appendArrows.querySelector('.slick-prev');
      
      this.nextArrow.addEventListener('click', (e) => {
        e.preventDefault();
        const scrollAmount = this.scrollType === 'horizontal' ? this.scroller.clientWidth - this.scrollPadding : this.scroller.clientHeight - this.scrollPadding;
        if ( this.scrollType === 'horizontal' ) {
          gsap.to(this.scroller, {
            scrollTo: {
              x: this.scroller.scrollLeft + scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        } else {
          gsap.to(this.scroller, {
            scrollTo: {
              y: this.scroller.scrollTop + scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        }
      });

      this.prevArrow.addEventListener('click', (e) => {
        e.preventDefault();
        const scrollAmount = this.scrollType === 'horizontal' ? this.scroller.clientWidth - this.scrollPadding : this.scroller.clientHeight - this.scrollPadding;
        if ( this.scrollType === 'horizontal' ) {
          gsap.to(this.scroller, {
            scrollTo: {
              x: this.scroller.scrollLeft - scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        } else {
          gsap.to(this.scroller, {
            scrollTo: {
              y: this.scroller.scrollTop - scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        }
      });
    }
  }

  assessScroll() {
    this.isScrollable = this.scrollType === 'horizontal' ? this.scroller.scrollWidth > this.scroller.clientWidth : this.scroller.scrollHeight > this.scroller.clientHeight;
    console.log( this.scroller.scrollHeight, this.scroller.clientHeight, this.isScrollable );

    if ( this.isScrollable ) {
      this.classTarget.classList.add('is-scrollable');
    } else {
      this.classTarget.classList.remove('is-scrollable');
    }
  }
}